import y from "react";
const t = "MM/dd/yyyy", e = "en-us", s = ["MM/dd/yyyy", "dd/MM/yyyy", "yyyy-MM-dd", "dd MMM yyyy"], d = [
  "de",
  "en",
  "en-us",
  "es",
  "es-ar",
  "fr",
  "fr-ca",
  "ja",
  "nl",
  "pt",
  "pt-br",
  "zh",
  "zh-cn"
], o = y.createContext({
  formatType: t,
  locale: e,
  utils: void 0
});
export {
  o as D,
  d as S,
  e as a,
  s as b,
  t as c
};
//# sourceMappingURL=date-picker-provider.domain-CocKbrk9.mjs.map
